import store from '@/store';

function normalizeCodes(value) {
  if (value == null || value === '') return [];
  if (Array.isArray(value)) return value.filter(Boolean).map(String);
  return [String(value)];
}

function hasAnyPerm(required) {
  const need = normalizeCodes(required);
  if (!need.length) return true;
  const owned = store.getters['user/permCodes'] || [];
  if (owned.includes('*') || owned.includes('SUPER_ADMIN')) {
    return true;
  }
  const roleCodes = (store.getters['user/userInfo'] && store.getters['user/userInfo'].roleCodes) || [];
  const roles = Array.isArray(roleCodes)
    ? roleCodes
    : String(roleCodes || '')
        .split(',')
        .map((s) => s.trim())
        .filter(Boolean);
  if (roles.includes('SUPER_ADMIN')) {
    return true;
  }
  return need.some((code) => owned.includes(code));
}

/**
 * v-permission="'exam:joint:edit'" 或 v-permission="['a','b']"（满足其一）
 * 无权限时移除节点。仅体验层，真实安全依赖后端 @RequirePerm / @RequireRoles。
 */
export default {
  inserted(el, binding) {
    if (!hasAnyPerm(binding.value)) {
      if (el.parentNode) {
        el.parentNode.removeChild(el);
      } else {
        el.style.display = 'none';
      }
    }
  }
};

export { hasAnyPerm };
